const PATH_FTP = "https://khaktus.fr/Cookyn/React"
// const API = "http://localhost:1313/api"
const API = "https://api.championnats.3fts.fr/api"
// const SOCKET = "http://localhost:1313"
const SOCKET = "https://api.championnats.3fts.fr"
// eslint-disable-next-line
export default {PATH_FTP, API, SOCKET}
